import { addselect, loadUrlPath, openFilter, setLocationErrorUI } from '../../../../../../modules/custom/ev_results/js/components/filters/filters';
import { loadProjects } from '../../../../../../modules/custom/ev_simulators/js/project/projectCards';
import { formState } from '../modules/form/FormState';
import { createdNoUiSlider, updateNoUiSlider } from '../components/noUiSlider';
let sliderWizard;
window.openFilter = openFilter;
window.nextPrev = nextPrev;
window.setFinancialMethod = setFinancialMethod;
window.setRangeCost = setRangeCost;
window.activeNextBtn = activeNextBtn;
// city filter
window.addselect = addselect;
document.addEventListener('DOMContentLoaded', function () {
    sliderWizard = document.getElementById('wizard-slider');
    setTimeout(() => {
        const config = {
            startMin: 157000000,
            startMax: 197000000,
            step: 10000000,
            min: 128115000,
            max: 249000000,
            labelMin: 'Precio mínimo',
            labelMax: 'Precio máximo',
        };
        createdNoUiSlider(sliderWizard, config);
        const snapValues = [
            document.getElementById('input-min'),
            document.getElementById('input-max')
        ];
        const inputValues = [
            document.querySelector('#stepperForm input[name="min_budget"]'),
            document.getElementsByName('max_budget')[0]
        ];
        let isUpdating = false;
        sliderWizard === null || sliderWizard === void 0 ? void 0 : sliderWizard.noUiSlider.on('update', function (values, handle) {
            const visHouseType = document.getElementById('visHouseType');
            const noVisHouseType = document.getElementById('noVisHouseType');
            snapValues[handle].innerHTML = '$' + new Intl.NumberFormat('es-ES').format(values[handle]);
            inputValues[handle].value = '$' + new Intl.NumberFormat('es-ES').format(values[handle]);
            document.getElementById('value-price').innerHTML = '$' + new Intl.NumberFormat('es-ES').format(values[0]) + ' - $' + new Intl.NumberFormat('es-ES').format(values[1]);
            if (isUpdating) {
                return;
            }
            else {
                isUpdating = true;
                const min = parseInt(values[0].toString());
                const max = parseInt(values[1].toString());
                const visHouseTypeChecked = visHouseType.checked;
                const noVisHouseTypeChecked = noVisHouseType.checked;
                const range = visHouseTypeChecked ? 40000000 : noVisHouseTypeChecked ? 100000000 : 0;
                const rangeHandle = visHouseTypeChecked ? 20000000 : noVisHouseTypeChecked ? 40000000 : 0;
                const minLimit = handle === 0 ? min : max - range;
                const maxLimit = handle === 1 ? max : min + range;
                const limitHandle = handle === 0 ? [max - rangeHandle, max] : [min, min + rangeHandle];
                if (max - min >= range) {
                    sliderWizard.noUiSlider.set([minLimit, maxLimit]);
                }
                else {
                    sliderWizard.noUiSlider.set(limitHandle);
                }
                isUpdating = false;
            }
        });
    }, 2000);
});
let currentTab = 0;
showTab(currentTab);
function showTab(n) {
    var _a, _b, _c, _d;
    const nContent = document.getElementsByClassName("tab");
    const prevBtn = document.getElementById("prevBtn");
    const contentSteps = document.getElementById("content-steps");
    if (nContent[n]) {
        nContent[n].style.display = "block";
    }
    if (prevBtn && contentSteps) {
        if (n === 0) {
            document.getElementById("prevBtn").style.display = "none";
            document.getElementById("content-steps").style.display = "none";
        }
        else {
            document.getElementById("prevBtn").style.display = "inline";
            document.getElementById("content-steps").style.display = "block";
        }
    }
    if (n === (nContent.length - 2)) {
        (_a = document.getElementById("submitBtn")) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
        (_b = document.getElementById("nextBtn")) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
    }
    else {
        (_c = document.getElementById("submitBtn")) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
        (_d = document.getElementById("nextBtn")) === null || _d === void 0 ? void 0 : _d.classList.remove('d-none');
    }
    fixStepIndicator(n);
}
let setFormData = false;
export function nextPrev(n) {
    var _a, _b, _c, _d;
    if (n === 1 && !validateCurrentTabWizard()) {
        return;
    }
    if (!setFormData) {
        formState.manageState('origen', 'Qué estás buscando');
        formState.manageState('referrer', 'wizard');
        formState.manageState('contextComponent', 'que-estas-buscando');
        formState.manageState('formName', '#stepperForm');
        (_a = document.getElementById('value-price-form')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
        setFormData = true;
    }
    const nTab = document.getElementsByClassName("tab");
    const prevTab = currentTab;
    nTab[currentTab].style.display = "none";
    currentTab = currentTab + n;
    showTab(currentTab);
    const toggleTab = n === 1 ? prevTab : currentTab;
    const positionForText = n === 1 ? prevTab : currentTab - 1;
    (_b = document.getElementsByClassName("step")[toggleTab]) === null || _b === void 0 ? void 0 : _b.classList.toggle('finish');
    (_c = document.getElementsByClassName("hr")[toggleTab]) === null || _c === void 0 ? void 0 : _c.classList.toggle('finish');
    const textTabs = (_d = document.getElementsByClassName("text-step")[positionForText]) === null || _d === void 0 ? void 0 : _d.innerHTML;
    document.getElementById('numberStep').innerHTML = textTabs || '';
}
function fixStepIndicator(n) {
    var _a;
    const steps = document.getElementsByClassName("step");
    Array.from(steps).forEach(step => step.classList.remove("active"));
    (_a = steps[n]) === null || _a === void 0 ? void 0 : _a.classList.add("active");
}
function validateCurrentTabWizard() {
    switch (currentTab) {
        case 1:
            return validateRadioStep('property_type', 'p.error-property-type');
        case 2:
            const checks = document.querySelectorAll('.js-builder-city-list li input');
            const hasSelection = Array.from(checks).some(i => i.checked);
            setLocationErrorUI(hasSelection); // esto ya muestra el mensaje y marca error
            return hasSelection; // puedes salir aquí
        case 4:
            return validateRadioStep('purchase_time', 'p.error-time');
        case 5:
            return validateRadioStep('habitar_invertir', 'p.error-buy-destination');
        default:
            return true;
    }
}
function validateRadioStep(radioName, errorSelector) {
    const inputChecked = !!document.querySelector(`input[type="radio"][name="${radioName}"]:checked`);
    const tab = document.querySelectorAll('.tab')[currentTab];
    if (tab && errorSelector) {
        const err = tab.querySelector(errorSelector);
        if (err)
            err.classList.toggle('is-visible', !inputChecked);
    }
    return inputChecked;
}
function activeNextBtn(value) {
    const idBtn = value ? 'nextBtn' + value.toString() : 'nextBtn';
    const nextBtn = document.getElementById(idBtn);
    if (!nextBtn)
        return;
    nextBtn.disabled = false;
    nextBtn.style.display = 'block'; // si igual lo quieren oculto inicialmente
}
function setRangeCost(type) {
    let text = '';
    let rangeStart = [];
    let rangeMin;
    let rangeMax;
    if (type === 'vis') {
        text = "El costo de la vivienda VIS está entre <b>$128.115.000</b> y <b>$249.000.000</b>";
        rangeStart = [147000000, 187000000];
        rangeMin = 128115000;
        rangeMax = 249000000;
    }
    else {
        text = "El costo de la vivienda NO VIS inicia en <b>$249.000.000</b>";
        rangeStart = [587000000, 687000000];
        rangeMin = 249000000;
        rangeMax = 1100000000;
    }
    document.getElementById('visNoVisText').innerHTML = text;
    const config = {
        startMin: rangeStart[0],
        startMax: rangeStart[1],
        min: rangeMin,
        max: rangeMax,
        labelMin: 'Costo mínimo',
        labelMax: 'Costo máximo'
    };
    updateNoUiSlider(sliderWizard, config);
    const minPrice = '$' + new Intl.NumberFormat('es-ES').format(sliderWizard.noUiSlider.get()[0]);
    const maxPrice = '$' + new Intl.NumberFormat('es-ES').format(sliderWizard.noUiSlider.get()[1]);
    document.getElementById('input-min').innerHTML = minPrice;
    document.getElementById('input-max').innerHTML = maxPrice;
    document.getElementById('value-price').innerHTML = minPrice + ' - ' + maxPrice;
}
function setFinancialMethod(value) {
    const target = event === null || event === void 0 ? void 0 : event.target;
    target.value = target.checked ? 'Sí' : 'No';
    const subsidyInfo = document.getElementById('subsidyInfo');
    const mortgageInfo = document.getElementById('mortgageInfo');
    const financialMethodsInfo = document.getElementById('financialMethodsInfo');
    if (value === 'subsidy') {
        subsidyInfo.classList.toggle('d-none');
    }
    if (value === 'mortgage') {
        mortgageInfo.classList.toggle('d-none');
    }
    const bothHidden = subsidyInfo.classList.contains('d-none') &&
        mortgageInfo.classList.contains('d-none');
    financialMethodsInfo.classList.toggle('d-none', bothHidden);
}
/**
 * Get the ID of the selected input from a nodeList.
 *
 * @param {string} id - The selector for the parent element (e.g., '#filterList').
 * @param {boolean} isNumber - The selector is number.
 * @returns {string} - The ID of the checked input, or 'all' if none is checked.
 */
export function getInputSelect(id, isNumber) {
    const selectedInput = document.querySelector(`${id} li input:checked`);
    const input = isNumber ? selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.id : selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.getAttribute('label');
    return input !== null && input !== void 0 ? input : 'all';
}
/**
 * Get the recommended typologies by location and price of inputs
 *
 * @param {string|null} cityId
 * @param {string|null} zoneId
 * @param {string|null} neighborhoodId
 * @param {array|null} price - The price range selected by the user in the form
 * @param {string|null} propertyType - The property type selected by the user VIS or NO VIS
 * @returns {array} - The tipology list with the data for print a collections of typologies, like the results section
 */
export function getRecommenderProjects(cityId, zoneId, neighborhoodId, price, propertyType) {
    let path = '/results-api?section_type=property_type';
    let isVis = false;
    propertyType.forEach(property => {
        if (property.checked && property.value == 'vis')
            isVis = true;
    });
    const min = price[0].replace(/\$|\./g, "");
    const max = price[1].replace(/\$|\./g, "");
    if (cityId && cityId != 'all')
        path += `&cities=${cityId}`;
    if (zoneId && zoneId != 'all')
        path += `&zone=${zoneId}`;
    if (neighborhoodId && neighborhoodId != 'all')
        path += `&sector=${neighborhoodId}`;
    path += `&price=${min},${max}`;
    path += isVis ? '&vis=11660,12211,11801' : '&vis=20220,20260,20223,7897';
    path += '&range=4&start=1';
    const field = neighborhoodId !== 'all' ? 'sector' :
        zoneId !== 'all' ? 'zone' :
            'cities';
    const dataForPath = field === 'sector' ? neighborhoodId :
        field === 'zone' ? zoneId :
            cityId;
    const portalPath = loadUrlPath(dataForPath, field, path, true);
    const portalHref = `${portalPath}?price=${min},${max}`;
    loadProjects('que-estas-buscando', path, portalHref);
    return { path, portalHref };
}
